/**
 * 线下培训班级列表功能
 * @Author:wuTao
 * @Date 2020/2/25
 */
import React from 'react';
import {connect} from 'dva';
import {reduxTemplateCofig, templateConfig} from './config';

import {framework_tool,component_tool} from '@/tool';

let {WizContainer, WizReduxTemplate} = framework_tool;
let { WizBrowserExport} = component_tool;

class ClassList extends WizContainer {

  componentName = 'ClassList';

  constructor(props) {
    super(props);
    const {history} = props
    let pathname = '/face/classList'
    if (history.location && history.location.pathname && history.location.pathname.startsWith('/perm/classListPerm')) {
      pathname = '/perm/classListPerm'
    }
    this.pathname = pathname
    this.state = {}
  }

  /**
   * 页面动作操作后进行提示
   * @param nextProps
   * @param nextState
   * @param key
   * @returns {boolean}
   * @private
   */
  _handleClass(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['data'] && typeof(o['data']) == 'string' ? o['data'] : o['msg']);
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '班级名称',
        field: 'name',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '班级类型',
        field: 'typeStr',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '开始时间',
        field: 'startDate',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '结束时间',
        field: 'endDate',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      //{
      //  headerName: '教室',
       // field: 'trainSiteName',
       // width: 20,
       // cellStyle: {
      //    textAlign: 'center',
        //},
        //style: {
      //    alignment: { vertical: 'bottom', horizontal: 'center' },
      //  },
      //},
      //{
      //  headerName: '培训中心',
      //  field: 'address',
       // width: 20,
      //  cellStyle: {
      ///    textAlign: 'center',
      //  },
      //  style: {
      //    alignment: { vertical: 'bottom', horizontal: 'center' },
       // },
      //},
      {
        headerName: '状态',
        field: 'statusStr',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '限制人数',
        field: 'limitNum',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '已参加人数',
        field: 'studentCount',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '实际可参加人数',
        field: 'realJoinCount',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '所属主题',
        field: 'programName',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '所属分类',
        field: 'typeName',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      // {
      //   headerName: '组班群聊',
      //   field: 'hasTeam',
      //   width: 10,
      //   cellStyle: {
      //     textAlign: 'center',
      //   },
      //   style: {
      //     alignment: { vertical: 'bottom', horizontal: 'center' },
      //   },
      // },
      // {
      //   headerName: '群聊状态',
      //   field: 'teamState',
      //   width: 20,
      //   cellStyle: {
      //     textAlign: 'center',
      //   },
      //   style: {
      //     alignment: { vertical: 'bottom', horizontal: 'center' },
      //   },
      // },
      {
        headerName: '满意度评分',
        field: 'scoreAvg',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      //{
      //  headerName: '讲师',
       // field: 'lectureName',
       // width: 30,
       // cellStyle: {
       //   textAlign: 'center',
       // },
       // style: {
       //   alignment: { vertical: 'bottom', horizontal: 'center' },
       // },
      //},
      //{
      //  headerName: '安全协议',
       // field: 'secProtocolStr',
      //  width: 15,
      //  cellStyle: {
      //    textAlign: 'center',
      //  },
      //  style: {
      //    alignment: { vertical: 'bottom', horizontal: 'center' },
      //  },
      //},
      //{
       // headerName: '保密协议',
       // field: 'conAgreementStr',
       // width: 15,
      //  cellStyle: {
      //    textAlign: 'center',
       // },
       // style: {
       //   alignment: { vertical: 'bottom', horizontal: 'center' },
       // },
      //},
      {
        headerName: '介绍',
        field: 'intro',
        width: 50,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '培训天数',
        field: 'studyDay',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '参训率',
        field: 'trainingRate',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      // {
      //   headerName: '创建人',
      //   field: 'fullName',
      //   width: 15,
      //   cellStyle: {
      //     textAlign: 'center',
      //   },
      //   style: {
      //     alignment: { vertical: 'bottom', horizontal: 'center' },
      //   },
      // },
      // {
      //   headerName: '创建时间',
      //   field: 'createTime',
      //   width: 20,
      //   cellStyle: {
      //     textAlign: 'center',
      //   },
      //   style: {
      //     alignment: { vertical: 'bottom', horizontal: 'center' },
      //   },
      // }

    ]
    if (o['success']) {
      let data = o['data']
      let hasTeamEnum = ['否', '是']
      let teamStateEnum = ['未开启', '已开启', '已解散']

      data.forEach(e => {
        e.hasTeam = hasTeamEnum[e.hasTeam]
        e.teamState = teamStateEnum[e.teamState]
      })

      WizBrowserExport({
        title: '班级信息',
        sheetName: '班级信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '班级信息.xlsx',
      })
      // wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFileLabels(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '编号',
        field: 'studentNumber',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '学生姓名',
        field: 'fullName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '邮箱',
        field: 'email',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '证件号码',
        field: 'idCard',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '手机号',
        field: 'mobile',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '账号状态',
        field: 'stateName',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '座位号',
        field: 'seatNumber',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '组织名称',
        field: 'orgName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '组织编码',
        field: 'orgCode',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '岗位',
        field: 'positionName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '任职状态',
        field: 'jobStateName',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      }

    ]
    if (o['success']) {
      let classInfo = o['data']['classInfo']
      let data = o['data']['classStudentDetails']
      WizBrowserExport({
        title: '课程名称: ' + classInfo.programName + '\n' + '班级名称: ' + classInfo.name + '\n' +
        '班级时间: ' + classInfo.startDate+'-'+classInfo.endDate+'\n'+'教室: '+classInfo.trainSiteName+'\n'+'培训中心: '+classInfo.address+'\n'+'讲师: '+classInfo.lectureName,
        sheetName: '班级门贴信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '班级门贴信息.xlsx',
        titleParams: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true },
          style: {
            alignment: { vertical: "bottom", horizontal: "left", wrapText: true },
          },
          font: {},
        },
        titleRow: {
          height: 70
        }
      })
      // wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _updateClassTeam(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig({pathname: this.pathname}),
      apiDataFormat: {
        add: this._handleClass,
        update: this._handleClass,
        delete: this._handleClass,
        updateClassStatus: this._handleClass,
        export: this._handleFile,
        look: this._handleClass,
        exportLabels: this._handleFileLabels,
        createClassTeam: this._updateClassTeam,
        removeClassTeam: this._updateClassTeam,
        syncClassTeam: this._updateClassTeam,
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(ClassList);
